<template>
    <v-container fluid>
        <v-row>
            <v-col lg="6" cols="sm" class="pb-2">
              <v-container grid-list-lg>
                <v-layout row justify-center>
                  <v-flex>
                    <networkDetails v-bind:networkDetails="networkDetails"/>
                  </v-flex>
                  <v-flex>
                    <environmentInformation v-bind:sensorType="sensorType" v-bind:environmentInfo="environmentInfo" v-bind:baselineInfo="baselineInfo"/>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-col>
            <v-col lg="6" cols="sm" class="pb-2">
                <alertsDashboard v-bind:alertsData="alertsData" v-bind:alertsSchema="alertsSchema"/>
            </v-col>
        </v-row>
        
        <!-- <v-row>
            <v-col lg="6" cols="sm" class="pb-2">
                <alertFlowOverTime />
            </v-col>
            <v-col lg="6" cols="sm" class="pb-2">
                <networkFlowOverTime />
            </v-col>
        </v-row> -->
    </v-container>
</template>


<script>
import networkDetails from '@/components/networkDetails.vue';
import environmentInformation from '@/components/environmentInformation.vue';
import alertsDashboard from '@/components/alertsDashboard.vue';
//import alertFlowOverTime from '@/components/alertFlowOverTime.vue';
//import networkFlowOverTime from '@/components/networkFlowOverTime.vue';

export default {
    components: {
        networkDetails,
        environmentInformation,
        alertsDashboard,
        //alertFlowOverTime,
        //networkFlowOverTime
    },
    props: {
        networkDetails: Object,
        sensorType: Array,
        environmentInfo: Object,
        baselineInfo: Object,
        alertsData: Array,
        alertsSchema: Object
    },    
    data: () => ({
    })
}
</script>